import React, { useEffect, useRef, useState, useMemo } from 'react';
import GroupManager from '../components/configuration/GroupManager';
import UserManager from '../components/configuration/UserManager';
import Breadcrumb from '../components/Breadcrumb';
import MenuBar from '../components/MenuBar';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import _ from 'lodash';

const Configuration = ({store, $routeParams, $rootScope, $location, allowedNodes}) => {

  const childRef = useRef(null);

  const baseBreadcrumbs = useMemo(() => [
    { breadcrumbName: "Repository Configuration" },
    {
      breadcrumbName: "",
      routeCollection: [
        {
          name: "User Manager",
          path: "/configuration/users",
          component: UserManager,
        },
      ],
    },
  ], []);

  const [menuItems, setMenuItems] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState(baseBreadcrumbs);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false); // make sure breadcrumbs are set before rendering

  useEffect(() => {
    setBreadcrumbs((prevBreadcrumbs) => {
      const newBreadcrumbs = [...prevBreadcrumbs];

      newBreadcrumbs[1] = {
        ...newBreadcrumbs[1],
        routeCollection: [
          ...(allowedNodes.includes("group manager")
              ? [{ name: "Group Manager", path: "/configuration/groups", component: GroupManager }]
              : []
          ),
          ...newBreadcrumbs[1].routeCollection,
        ],
      };

      if (_.isEqual(prevBreadcrumbs, newBreadcrumbs)) {
        return prevBreadcrumbs;
      }

      return newBreadcrumbs;
    });
    
    setInitialLoadComplete(true);

  }, [allowedNodes, baseBreadcrumbs]);

  const ConfigNode = useMemo(() => {
    let component = null;
    breadcrumbs.forEach((breadcrumb) => {
      if (breadcrumb.routeCollection) {
        const route = breadcrumb.routeCollection.find(r => r.path === $location.path());
        if (route) {
          component = route.component;
        }
      }
    });
    return component;
  }, [breadcrumbs, $location.path()]);

  useEffect(() => {
    if (!ConfigNode && initialLoadComplete) {
      $location.path("/configuration/users"); // send users to default page if they try to access a restricted page
    }
  }, [ConfigNode, $location, initialLoadComplete]);

  return (
    <>
      <div className="action-menu">
        <MenuBar
          menuItems={menuItems}
          onClick={(action) => {
            childRef.current.onButtonClick(action);
          }}
        />
      </div>
      <Breadcrumb
        disableLink={true}
        paths={breadcrumbs}
        $location={$location}
        $routeParams={$routeParams}
        $rootScope={$rootScope}
      />
      <Provider store={store}>
        {ConfigNode && (
          <ConfigNode
            ref={childRef}
            location={$location}
            rootScope={$rootScope}
            routeParams={$routeParams}
            setMenuItems={setMenuItems}
          />
        )}
      </Provider>
    </>
  );
};

const mapStateToProps = (state) => {
  const { allowedNodes } = state.user;
  return { allowedNodes };
};

export default connect(mapStateToProps)(Configuration);